// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IMinimumInvestmentAmountPropertyDto } from './IMinimumInvestmentAmountPropertyDto';
import {
    IMinimumInvestmentAmountPropertyDtoFromJSON,
    IMinimumInvestmentAmountPropertyDtoFromJSONTyped,
    IMinimumInvestmentAmountPropertyDtoToJSON,
    IMinimumInvestmentAmountPropertyDtoToJSONTyped,
} from './IMinimumInvestmentAmountPropertyDto';
import type { IIsCardedPropertyDto } from './IIsCardedPropertyDto';
import {
    IIsCardedPropertyDtoFromJSON,
    IIsCardedPropertyDtoFromJSONTyped,
    IIsCardedPropertyDtoToJSON,
    IIsCardedPropertyDtoToJSONTyped,
} from './IIsCardedPropertyDto';
import type { IIsCipRequiredPropertyDto } from './IIsCipRequiredPropertyDto';
import {
    IIsCipRequiredPropertyDtoFromJSON,
    IIsCipRequiredPropertyDtoFromJSONTyped,
    IIsCipRequiredPropertyDtoToJSON,
    IIsCipRequiredPropertyDtoToJSONTyped,
} from './IIsCipRequiredPropertyDto';
import type { IProofOfExpensesCardTypePropertyDto } from './IProofOfExpensesCardTypePropertyDto';
import {
    IProofOfExpensesCardTypePropertyDtoFromJSON,
    IProofOfExpensesCardTypePropertyDtoFromJSONTyped,
    IProofOfExpensesCardTypePropertyDtoToJSON,
    IProofOfExpensesCardTypePropertyDtoToJSONTyped,
} from './IProofOfExpensesCardTypePropertyDto';
import type { IInvestmentOptionsTypePropertyDto } from './IInvestmentOptionsTypePropertyDto';
import {
    IInvestmentOptionsTypePropertyDtoFromJSON,
    IInvestmentOptionsTypePropertyDtoFromJSONTyped,
    IInvestmentOptionsTypePropertyDtoToJSON,
    IInvestmentOptionsTypePropertyDtoToJSONTyped,
} from './IInvestmentOptionsTypePropertyDto';
import type { ISpendLimitTypePropertyDto } from './ISpendLimitTypePropertyDto';
import {
    ISpendLimitTypePropertyDtoFromJSON,
    ISpendLimitTypePropertyDtoFromJSONTyped,
    ISpendLimitTypePropertyDtoToJSON,
    ISpendLimitTypePropertyDtoToJSONTyped,
} from './ISpendLimitTypePropertyDto';
import type { IFundIdPropertyDto } from './IFundIdPropertyDto';
import {
    IFundIdPropertyDtoFromJSON,
    IFundIdPropertyDtoFromJSONTyped,
    IFundIdPropertyDtoToJSON,
    IFundIdPropertyDtoToJSONTyped,
} from './IFundIdPropertyDto';
import type { IInvestmentThresholdPropertyDto } from './IInvestmentThresholdPropertyDto';
import {
    IInvestmentThresholdPropertyDtoFromJSON,
    IInvestmentThresholdPropertyDtoFromJSONTyped,
    IInvestmentThresholdPropertyDtoToJSON,
    IInvestmentThresholdPropertyDtoToJSONTyped,
} from './IInvestmentThresholdPropertyDto';
import type { ICatchUpElectionPropertyDto } from './ICatchUpElectionPropertyDto';
import {
    ICatchUpElectionPropertyDtoFromJSON,
    ICatchUpElectionPropertyDtoFromJSONTyped,
    ICatchUpElectionPropertyDtoToJSON,
    ICatchUpElectionPropertyDtoToJSONTyped,
} from './ICatchUpElectionPropertyDto';
import type { IOmnibusTypePropertyDto } from './IOmnibusTypePropertyDto';
import {
    IOmnibusTypePropertyDtoFromJSON,
    IOmnibusTypePropertyDtoFromJSONTyped,
    IOmnibusTypePropertyDtoToJSON,
    IOmnibusTypePropertyDtoToJSONTyped,
} from './IOmnibusTypePropertyDto';
import type { IMaxElectionAmountTypePropertyDto } from './IMaxElectionAmountTypePropertyDto';
import {
    IMaxElectionAmountTypePropertyDtoFromJSON,
    IMaxElectionAmountTypePropertyDtoFromJSONTyped,
    IMaxElectionAmountTypePropertyDtoToJSON,
    IMaxElectionAmountTypePropertyDtoToJSONTyped,
} from './IMaxElectionAmountTypePropertyDto';
import type { IPerPersonSpendLimitAmountPropertyDto } from './IPerPersonSpendLimitAmountPropertyDto';
import {
    IPerPersonSpendLimitAmountPropertyDtoFromJSON,
    IPerPersonSpendLimitAmountPropertyDtoFromJSONTyped,
    IPerPersonSpendLimitAmountPropertyDtoToJSON,
    IPerPersonSpendLimitAmountPropertyDtoToJSONTyped,
} from './IPerPersonSpendLimitAmountPropertyDto';
import type { ILuGpDesignationAllowedPropertyDto } from './ILuGpDesignationAllowedPropertyDto';
import {
    ILuGpDesignationAllowedPropertyDtoFromJSON,
    ILuGpDesignationAllowedPropertyDtoFromJSONTyped,
    ILuGpDesignationAllowedPropertyDtoToJSON,
    ILuGpDesignationAllowedPropertyDtoToJSONTyped,
} from './ILuGpDesignationAllowedPropertyDto';
import type { ICmsReportingRequiredPropertyDto } from './ICmsReportingRequiredPropertyDto';
import {
    ICmsReportingRequiredPropertyDtoFromJSON,
    ICmsReportingRequiredPropertyDtoFromJSONTyped,
    ICmsReportingRequiredPropertyDtoToJSON,
    ICmsReportingRequiredPropertyDtoToJSONTyped,
} from './ICmsReportingRequiredPropertyDto';
import type { IPerPersonSpendLimitPropertyDto } from './IPerPersonSpendLimitPropertyDto';
import {
    IPerPersonSpendLimitPropertyDtoFromJSON,
    IPerPersonSpendLimitPropertyDtoFromJSONTyped,
    IPerPersonSpendLimitPropertyDtoToJSON,
    IPerPersonSpendLimitPropertyDtoToJSONTyped,
} from './IPerPersonSpendLimitPropertyDto';
import type { ICatchUpAgePropertyDto } from './ICatchUpAgePropertyDto';
import {
    ICatchUpAgePropertyDtoFromJSON,
    ICatchUpAgePropertyDtoFromJSONTyped,
    ICatchUpAgePropertyDtoToJSON,
    ICatchUpAgePropertyDtoToJSONTyped,
} from './ICatchUpAgePropertyDto';
import type { IIncludeToBalanceReminderPropertyDto } from './IIncludeToBalanceReminderPropertyDto';
import {
    IIncludeToBalanceReminderPropertyDtoFromJSON,
    IIncludeToBalanceReminderPropertyDtoFromJSONTyped,
    IIncludeToBalanceReminderPropertyDtoToJSON,
    IIncludeToBalanceReminderPropertyDtoToJSONTyped,
} from './IIncludeToBalanceReminderPropertyDto';
import type { IPendContributionsForCipPropertyDto } from './IPendContributionsForCipPropertyDto';
import {
    IPendContributionsForCipPropertyDtoFromJSON,
    IPendContributionsForCipPropertyDtoFromJSONTyped,
    IPendContributionsForCipPropertyDtoToJSON,
    IPendContributionsForCipPropertyDtoToJSONTyped,
} from './IPendContributionsForCipPropertyDto';
import type { IAllowInvestmentsPropertyDto } from './IAllowInvestmentsPropertyDto';
import {
    IAllowInvestmentsPropertyDtoFromJSON,
    IAllowInvestmentsPropertyDtoFromJSONTyped,
    IAllowInvestmentsPropertyDtoToJSON,
    IAllowInvestmentsPropertyDtoToJSONTyped,
} from './IAllowInvestmentsPropertyDto';
import type { ICipAccountClosureDelayDaysPropertyDto } from './ICipAccountClosureDelayDaysPropertyDto';
import {
    ICipAccountClosureDelayDaysPropertyDtoFromJSON,
    ICipAccountClosureDelayDaysPropertyDtoFromJSONTyped,
    ICipAccountClosureDelayDaysPropertyDtoToJSON,
    ICipAccountClosureDelayDaysPropertyDtoToJSONTyped,
} from './ICipAccountClosureDelayDaysPropertyDto';
import type { IIsReplenishedPropertyDto } from './IIsReplenishedPropertyDto';
import {
    IIsReplenishedPropertyDtoFromJSON,
    IIsReplenishedPropertyDtoFromJSONTyped,
    IIsReplenishedPropertyDtoToJSON,
    IIsReplenishedPropertyDtoToJSONTyped,
} from './IIsReplenishedPropertyDto';
import type { IReturnFundsAfterCipAccountClosureTypePropertyDto } from './IReturnFundsAfterCipAccountClosureTypePropertyDto';
import {
    IReturnFundsAfterCipAccountClosureTypePropertyDtoFromJSON,
    IReturnFundsAfterCipAccountClosureTypePropertyDtoFromJSONTyped,
    IReturnFundsAfterCipAccountClosureTypePropertyDtoToJSON,
    IReturnFundsAfterCipAccountClosureTypePropertyDtoToJSONTyped,
} from './IReturnFundsAfterCipAccountClosureTypePropertyDto';
import type { IAvailableBalanceTypePropertyDto } from './IAvailableBalanceTypePropertyDto';
import {
    IAvailableBalanceTypePropertyDtoFromJSON,
    IAvailableBalanceTypePropertyDtoFromJSONTyped,
    IAvailableBalanceTypePropertyDtoToJSON,
    IAvailableBalanceTypePropertyDtoToJSONTyped,
} from './IAvailableBalanceTypePropertyDto';
import type { IIgnoreElectionLimitPropertyDto } from './IIgnoreElectionLimitPropertyDto';
import {
    IIgnoreElectionLimitPropertyDtoFromJSON,
    IIgnoreElectionLimitPropertyDtoFromJSONTyped,
    IIgnoreElectionLimitPropertyDtoToJSON,
    IIgnoreElectionLimitPropertyDtoToJSONTyped,
} from './IIgnoreElectionLimitPropertyDto';
import type { IFundIdFormulaPropertyDto } from './IFundIdFormulaPropertyDto';
import {
    IFundIdFormulaPropertyDtoFromJSON,
    IFundIdFormulaPropertyDtoFromJSONTyped,
    IFundIdFormulaPropertyDtoToJSON,
    IFundIdFormulaPropertyDtoToJSONTyped,
} from './IFundIdFormulaPropertyDto';
import type { IGenerateStatementsDto } from './IGenerateStatementsDto';
import {
    IGenerateStatementsDtoFromJSON,
    IGenerateStatementsDtoFromJSONTyped,
    IGenerateStatementsDtoToJSON,
    IGenerateStatementsDtoToJSONTyped,
} from './IGenerateStatementsDto';
import type { IMinElectionAmountTypePropertyDto } from './IMinElectionAmountTypePropertyDto';
import {
    IMinElectionAmountTypePropertyDtoFromJSON,
    IMinElectionAmountTypePropertyDtoFromJSONTyped,
    IMinElectionAmountTypePropertyDtoToJSON,
    IMinElectionAmountTypePropertyDtoToJSONTyped,
} from './IMinElectionAmountTypePropertyDto';
import type { ISpendPeriodTypePropertyDto } from './ISpendPeriodTypePropertyDto';
import {
    ISpendPeriodTypePropertyDtoFromJSON,
    ISpendPeriodTypePropertyDtoFromJSONTyped,
    ISpendPeriodTypePropertyDtoToJSON,
    ISpendPeriodTypePropertyDtoToJSONTyped,
} from './ISpendPeriodTypePropertyDto';
import type { IIsOrphanedPropertyDto } from './IIsOrphanedPropertyDto';
import {
    IIsOrphanedPropertyDtoFromJSON,
    IIsOrphanedPropertyDtoFromJSONTyped,
    IIsOrphanedPropertyDtoToJSON,
    IIsOrphanedPropertyDtoToJSONTyped,
} from './IIsOrphanedPropertyDto';
import type { IProofOfExpensesTypePropertyDto } from './IProofOfExpensesTypePropertyDto';
import {
    IProofOfExpensesTypePropertyDtoFromJSON,
    IProofOfExpensesTypePropertyDtoFromJSONTyped,
    IProofOfExpensesTypePropertyDtoToJSON,
    IProofOfExpensesTypePropertyDtoToJSONTyped,
} from './IProofOfExpensesTypePropertyDto';
import type { IPerCategorySpendLimitPropertyDto } from './IPerCategorySpendLimitPropertyDto';
import {
    IPerCategorySpendLimitPropertyDtoFromJSON,
    IPerCategorySpendLimitPropertyDtoFromJSONTyped,
    IPerCategorySpendLimitPropertyDtoToJSON,
    IPerCategorySpendLimitPropertyDtoToJSONTyped,
} from './IPerCategorySpendLimitPropertyDto';
import type { IFundingMethodTypePropertyDto } from './IFundingMethodTypePropertyDto';
import {
    IFundingMethodTypePropertyDtoFromJSON,
    IFundingMethodTypePropertyDtoFromJSONTyped,
    IFundingMethodTypePropertyDtoToJSON,
    IFundingMethodTypePropertyDtoToJSONTyped,
} from './IFundingMethodTypePropertyDto';

/**
 * 
 * @export
 * @interface IPlanPrimaryConfigDto
 */
export interface IPlanPrimaryConfigDto {
    /**
     * 
     * @type {IAvailableBalanceTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    available_balance_type?: IAvailableBalanceTypePropertyDto;
    /**
     * 
     * @type {IMaxElectionAmountTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    max_election_amount_type?: IMaxElectionAmountTypePropertyDto;
    /**
     * 
     * @type {IMinElectionAmountTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    min_election_amount_type?: IMinElectionAmountTypePropertyDto;
    /**
     * 
     * @type {IIsCardedPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    is_carded?: IIsCardedPropertyDto;
    /**
     * 
     * @type {IIsCipRequiredPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    is_cip_required?: IIsCipRequiredPropertyDto;
    /**
     * 
     * @type {ICipAccountClosureDelayDaysPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    cip_account_closure_delay_days?: ICipAccountClosureDelayDaysPropertyDto;
    /**
     * 
     * @type {IReturnFundsAfterCipAccountClosureTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    return_funds_after_cip_account_closure_type?: IReturnFundsAfterCipAccountClosureTypePropertyDto;
    /**
     * 
     * @type {IOmnibusTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    omnibus_type?: IOmnibusTypePropertyDto;
    /**
     * 
     * @type {IIsReplenishedPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    is_replenished?: IIsReplenishedPropertyDto;
    /**
     * 
     * @type {IFundIdPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    fund_id?: IFundIdPropertyDto;
    /**
     * 
     * @type {IFundIdFormulaPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    fund_id_formula?: IFundIdFormulaPropertyDto;
    /**
     * 
     * @type {IProofOfExpensesTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    proof_of_expenses_type?: IProofOfExpensesTypePropertyDto;
    /**
     * 
     * @type {IProofOfExpensesCardTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    proof_of_expenses_card_type?: IProofOfExpensesCardTypePropertyDto;
    /**
     * 
     * @type {IAllowInvestmentsPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    allow_investments?: IAllowInvestmentsPropertyDto;
    /**
     * 
     * @type {ICatchUpElectionPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    catch_up_election?: ICatchUpElectionPropertyDto;
    /**
     * 
     * @type {ICatchUpAgePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    catch_up_age?: ICatchUpAgePropertyDto;
    /**
     * 
     * @type {IInvestmentOptionsTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    investment_options_type?: IInvestmentOptionsTypePropertyDto;
    /**
     * 
     * @type {IInvestmentThresholdPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    investment_threshold?: IInvestmentThresholdPropertyDto;
    /**
     * 
     * @type {IMinimumInvestmentAmountPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    minimum_investment_amount?: IMinimumInvestmentAmountPropertyDto;
    /**
     * 
     * @type {IPendContributionsForCipPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    pend_contributions_for_cip?: IPendContributionsForCipPropertyDto;
    /**
     * 
     * @type {ICmsReportingRequiredPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    cms_reporting_required?: ICmsReportingRequiredPropertyDto;
    /**
     * 
     * @type {ISpendLimitTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    spend_limit_type?: ISpendLimitTypePropertyDto;
    /**
     * 
     * @type {ISpendPeriodTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    spend_period_type?: ISpendPeriodTypePropertyDto;
    /**
     * 
     * @type {IIsOrphanedPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    is_orphaned?: IIsOrphanedPropertyDto;
    /**
     * 
     * @type {IGenerateStatementsDto}
     * @memberof IPlanPrimaryConfigDto
     */
    generate_statements?: IGenerateStatementsDto;
    /**
     * 
     * @type {IIncludeToBalanceReminderPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    include_to_balance_reminder?: IIncludeToBalanceReminderPropertyDto;
    /**
     * 
     * @type {IFundingMethodTypePropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    funding_method_type?: IFundingMethodTypePropertyDto;
    /**
     * 
     * @type {IIgnoreElectionLimitPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    ignore_election_limit?: IIgnoreElectionLimitPropertyDto;
    /**
     * 
     * @type {IPerPersonSpendLimitPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    per_person_spend_limit?: IPerPersonSpendLimitPropertyDto;
    /**
     * 
     * @type {IPerPersonSpendLimitAmountPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    per_person_spend_limit_amount?: IPerPersonSpendLimitAmountPropertyDto;
    /**
     * 
     * @type {IPerCategorySpendLimitPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    per_category_spend_limit?: IPerCategorySpendLimitPropertyDto;
    /**
     * 
     * @type {ILuGpDesignationAllowedPropertyDto}
     * @memberof IPlanPrimaryConfigDto
     */
    lu_gp_designation_allowed?: ILuGpDesignationAllowedPropertyDto;
}

/**
 * Check if a given object implements the IPlanPrimaryConfigDto interface.
 */
export function instanceOfIPlanPrimaryConfigDto(value: object): value is IPlanPrimaryConfigDto {
    return true;
}

export function IPlanPrimaryConfigDtoFromJSON(json: any): IPlanPrimaryConfigDto {
    return IPlanPrimaryConfigDtoFromJSONTyped(json, false);
}

export function IPlanPrimaryConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanPrimaryConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'available_balance_type': json['available_balance_type'] == null ? undefined : IAvailableBalanceTypePropertyDtoFromJSON(json['available_balance_type']),
        'max_election_amount_type': json['max_election_amount_type'] == null ? undefined : IMaxElectionAmountTypePropertyDtoFromJSON(json['max_election_amount_type']),
        'min_election_amount_type': json['min_election_amount_type'] == null ? undefined : IMinElectionAmountTypePropertyDtoFromJSON(json['min_election_amount_type']),
        'is_carded': json['is_carded'] == null ? undefined : IIsCardedPropertyDtoFromJSON(json['is_carded']),
        'is_cip_required': json['is_cip_required'] == null ? undefined : IIsCipRequiredPropertyDtoFromJSON(json['is_cip_required']),
        'cip_account_closure_delay_days': json['cip_account_closure_delay_days'] == null ? undefined : ICipAccountClosureDelayDaysPropertyDtoFromJSON(json['cip_account_closure_delay_days']),
        'return_funds_after_cip_account_closure_type': json['return_funds_after_cip_account_closure_type'] == null ? undefined : IReturnFundsAfterCipAccountClosureTypePropertyDtoFromJSON(json['return_funds_after_cip_account_closure_type']),
        'omnibus_type': json['omnibus_type'] == null ? undefined : IOmnibusTypePropertyDtoFromJSON(json['omnibus_type']),
        'is_replenished': json['is_replenished'] == null ? undefined : IIsReplenishedPropertyDtoFromJSON(json['is_replenished']),
        'fund_id': json['fund_id'] == null ? undefined : IFundIdPropertyDtoFromJSON(json['fund_id']),
        'fund_id_formula': json['fund_id_formula'] == null ? undefined : IFundIdFormulaPropertyDtoFromJSON(json['fund_id_formula']),
        'proof_of_expenses_type': json['proof_of_expenses_type'] == null ? undefined : IProofOfExpensesTypePropertyDtoFromJSON(json['proof_of_expenses_type']),
        'proof_of_expenses_card_type': json['proof_of_expenses_card_type'] == null ? undefined : IProofOfExpensesCardTypePropertyDtoFromJSON(json['proof_of_expenses_card_type']),
        'allow_investments': json['allow_investments'] == null ? undefined : IAllowInvestmentsPropertyDtoFromJSON(json['allow_investments']),
        'catch_up_election': json['catch_up_election'] == null ? undefined : ICatchUpElectionPropertyDtoFromJSON(json['catch_up_election']),
        'catch_up_age': json['catch_up_age'] == null ? undefined : ICatchUpAgePropertyDtoFromJSON(json['catch_up_age']),
        'investment_options_type': json['investment_options_type'] == null ? undefined : IInvestmentOptionsTypePropertyDtoFromJSON(json['investment_options_type']),
        'investment_threshold': json['investment_threshold'] == null ? undefined : IInvestmentThresholdPropertyDtoFromJSON(json['investment_threshold']),
        'minimum_investment_amount': json['minimum_investment_amount'] == null ? undefined : IMinimumInvestmentAmountPropertyDtoFromJSON(json['minimum_investment_amount']),
        'pend_contributions_for_cip': json['pend_contributions_for_cip'] == null ? undefined : IPendContributionsForCipPropertyDtoFromJSON(json['pend_contributions_for_cip']),
        'cms_reporting_required': json['cms_reporting_required'] == null ? undefined : ICmsReportingRequiredPropertyDtoFromJSON(json['cms_reporting_required']),
        'spend_limit_type': json['spend_limit_type'] == null ? undefined : ISpendLimitTypePropertyDtoFromJSON(json['spend_limit_type']),
        'spend_period_type': json['spend_period_type'] == null ? undefined : ISpendPeriodTypePropertyDtoFromJSON(json['spend_period_type']),
        'is_orphaned': json['is_orphaned'] == null ? undefined : IIsOrphanedPropertyDtoFromJSON(json['is_orphaned']),
        'generate_statements': json['generate_statements'] == null ? undefined : IGenerateStatementsDtoFromJSON(json['generate_statements']),
        'include_to_balance_reminder': json['include_to_balance_reminder'] == null ? undefined : IIncludeToBalanceReminderPropertyDtoFromJSON(json['include_to_balance_reminder']),
        'funding_method_type': json['funding_method_type'] == null ? undefined : IFundingMethodTypePropertyDtoFromJSON(json['funding_method_type']),
        'ignore_election_limit': json['ignore_election_limit'] == null ? undefined : IIgnoreElectionLimitPropertyDtoFromJSON(json['ignore_election_limit']),
        'per_person_spend_limit': json['per_person_spend_limit'] == null ? undefined : IPerPersonSpendLimitPropertyDtoFromJSON(json['per_person_spend_limit']),
        'per_person_spend_limit_amount': json['per_person_spend_limit_amount'] == null ? undefined : IPerPersonSpendLimitAmountPropertyDtoFromJSON(json['per_person_spend_limit_amount']),
        'per_category_spend_limit': json['per_category_spend_limit'] == null ? undefined : IPerCategorySpendLimitPropertyDtoFromJSON(json['per_category_spend_limit']),
        'lu_gp_designation_allowed': json['lu_gp_designation_allowed'] == null ? undefined : ILuGpDesignationAllowedPropertyDtoFromJSON(json['lu_gp_designation_allowed']),
    };
}

export function IPlanPrimaryConfigDtoToJSON(json: any): IPlanPrimaryConfigDto {
    return IPlanPrimaryConfigDtoToJSONTyped(json, false);
}

export function IPlanPrimaryConfigDtoToJSONTyped(value?: IPlanPrimaryConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available_balance_type': IAvailableBalanceTypePropertyDtoToJSON(value['available_balance_type']),
        'max_election_amount_type': IMaxElectionAmountTypePropertyDtoToJSON(value['max_election_amount_type']),
        'min_election_amount_type': IMinElectionAmountTypePropertyDtoToJSON(value['min_election_amount_type']),
        'is_carded': IIsCardedPropertyDtoToJSON(value['is_carded']),
        'is_cip_required': IIsCipRequiredPropertyDtoToJSON(value['is_cip_required']),
        'cip_account_closure_delay_days': ICipAccountClosureDelayDaysPropertyDtoToJSON(value['cip_account_closure_delay_days']),
        'return_funds_after_cip_account_closure_type': IReturnFundsAfterCipAccountClosureTypePropertyDtoToJSON(value['return_funds_after_cip_account_closure_type']),
        'omnibus_type': IOmnibusTypePropertyDtoToJSON(value['omnibus_type']),
        'is_replenished': IIsReplenishedPropertyDtoToJSON(value['is_replenished']),
        'fund_id': IFundIdPropertyDtoToJSON(value['fund_id']),
        'fund_id_formula': IFundIdFormulaPropertyDtoToJSON(value['fund_id_formula']),
        'proof_of_expenses_type': IProofOfExpensesTypePropertyDtoToJSON(value['proof_of_expenses_type']),
        'proof_of_expenses_card_type': IProofOfExpensesCardTypePropertyDtoToJSON(value['proof_of_expenses_card_type']),
        'allow_investments': IAllowInvestmentsPropertyDtoToJSON(value['allow_investments']),
        'catch_up_election': ICatchUpElectionPropertyDtoToJSON(value['catch_up_election']),
        'catch_up_age': ICatchUpAgePropertyDtoToJSON(value['catch_up_age']),
        'investment_options_type': IInvestmentOptionsTypePropertyDtoToJSON(value['investment_options_type']),
        'investment_threshold': IInvestmentThresholdPropertyDtoToJSON(value['investment_threshold']),
        'minimum_investment_amount': IMinimumInvestmentAmountPropertyDtoToJSON(value['minimum_investment_amount']),
        'pend_contributions_for_cip': IPendContributionsForCipPropertyDtoToJSON(value['pend_contributions_for_cip']),
        'cms_reporting_required': ICmsReportingRequiredPropertyDtoToJSON(value['cms_reporting_required']),
        'spend_limit_type': ISpendLimitTypePropertyDtoToJSON(value['spend_limit_type']),
        'spend_period_type': ISpendPeriodTypePropertyDtoToJSON(value['spend_period_type']),
        'is_orphaned': IIsOrphanedPropertyDtoToJSON(value['is_orphaned']),
        'generate_statements': IGenerateStatementsDtoToJSON(value['generate_statements']),
        'include_to_balance_reminder': IIncludeToBalanceReminderPropertyDtoToJSON(value['include_to_balance_reminder']),
        'funding_method_type': IFundingMethodTypePropertyDtoToJSON(value['funding_method_type']),
        'ignore_election_limit': IIgnoreElectionLimitPropertyDtoToJSON(value['ignore_election_limit']),
        'per_person_spend_limit': IPerPersonSpendLimitPropertyDtoToJSON(value['per_person_spend_limit']),
        'per_person_spend_limit_amount': IPerPersonSpendLimitAmountPropertyDtoToJSON(value['per_person_spend_limit_amount']),
        'per_category_spend_limit': IPerCategorySpendLimitPropertyDtoToJSON(value['per_category_spend_limit']),
        'lu_gp_designation_allowed': ILuGpDesignationAllowedPropertyDtoToJSON(value['lu_gp_designation_allowed']),
    };
}

